module.exports = __webpack_public_path__ + "static/media/cart_plus.50f81c3d.svg";